// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__ziZXJ","alertIcon":"ConfirmModal_alertIcon__299Al"};